import { render } from "./RegisterView.vue?vue&type=template&id=2b9cbab6&ts=true"
import script from "./RegisterView.vue?vue&type=script&lang=ts"
export * from "./RegisterView.vue?vue&type=script&lang=ts"

import "./RegisterView.vue?vue&type=style&index=0&id=2b9cbab6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__